import styled from 'styled-components';

export const Container = styled.div`
  margin: 30px auto;
  max-width: 50vw;
  width: 80%;
font-family: system-ui,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji;

@media only screen and (max-width: 600px) {
    max-width: 100vw;
    width: 90%;
}
`;

export const Title = styled.h1`
    color: white;
    font-weight: bold;
    text-align: center;
`;

export const Description = styled.p`
    color: white;
    font-weight: normal;
    text-align: center;
    letter-spacing: 0.1em;
`;

export const Content = styled.p`
    color: white;
    font-weight: lighter;
    text-align: center;
    letter-spacing: 0.1em;
    line-spacing: 1px;
`;

export const NewLine = styled.br``;


export const Point = styled.b`
    font-weight: bold;
`;